/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from "react";
import createSvgIcon from './utils/createSvgIcon';
var disabledProps = {
  fill: true
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M50.25,43.886039 L89.5979797,4.53805922 C91.3553391,2.78069991 94.2045815,2.78069991 95.9619408,4.53805922 C97.7193001,6.29541854 97.7193001,9.14466094 95.9619408,10.9020203 L56.613961,50.25 L96.1500179,89.7860569 C97.9073773,91.5434162 97.9073773,94.3926586 96.1500179,96.1500179 C94.3926586,97.9073773 91.5434162,97.9073773 89.7860569,96.1500179 L50.25,56.613961 L10.4020203,96.4619408 C8.64466094,98.2193001 5.79541854,98.2193001 4.03805922,96.4619408 C2.28069991,94.7045815 2.28069991,91.8553391 4.03805922,90.0979797 L43.886039,50.25 L4.22613639,10.5900974 C2.46877708,8.83273811 2.46877708,5.98349571 4.22613639,4.22613639 C5.98349571,2.46877708 8.83273811,2.46877708 10.5900974,4.22613639 L50.25,43.886039 Z"
})), 'CloseIcon', disabledProps);